import Vue from 'vue';

Vue.filter('prettyTime', function (value) {
	let secs = parseInt(value);
	let mins = Math.floor(secs / 60);
	let hrs = Math.floor(mins / 60);
	secs = secs % 60;
	mins = mins % 60;
	secs = secs + "";
	mins = mins + "";
	if (hrs) {
		return `${hrs}:${mins.padStart(2, '0')}:${secs.padStart(2, '0')}`;
	} else {
		return `${mins}:${secs.padStart(2, '0')}`;
	}
})
